import {DateUtil} from "base/format/utilities";
import {TextLink} from "base/navigation/components";
import {ViolationTypeTags} from "violation/presentational";

export function useViolationsSummaryTable() {
    const tableColumns = [
        {
            id: "code",
            label: "Código",
            width: 15,
            formatFunction: item => (
                <TextLink
                    text={item?.code}
                    to={`/violations/all/list/${item.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
        },
        {
            id: "on_date",
            label: "Data",
            width: 15,
            formatFunction: item => DateUtil.formatDate(item.on_date),
        },
        {
            id: "district",
            label: "Distrito",
            width: 20,
        },
        {
            id: "status",
            label: "Estado",
            width: 20,
        },
        {
            id: "types",
            label: "Tipo",
            formatFunction: item => {
                return <ViolationTypeTags types={item?.types} />;
            },
            disableSorting: true,
            width: 30,
        },
    ];

    return {tableColumns};
}
